// src/api/programService.js
import apiClient from "./apiClient";

// 🔹 Get all programs
export const getPrograms = async (params = {}) => {
  const response = await apiClient.get("/programs/", { params });
  return response.data;
};

// 🔹 Get program by ID
export const getProgramById = async (id) => {
  const response = await apiClient.get(`/programs/${id}`);
  return response.data;
};

// 🔹 Get all programs under a department
export const getProgramsByDepartment = async (departmentId) => {
  const response = await apiClient.get(`/programs/by_department/${departmentId}`);
  return response.data;
};

// 🔹 Create a new program
export const createProgram = async (data) => {
  const response = await apiClient.post("/programs/", data);
  return response.data;
};

// 🔹 Update program details
export const updateProgram = async (id, data) => {
  const response = await apiClient.put(`/programs/${id}`, data);
  return response.data;
};

// 🔹 Delete a program
export const deleteProgram = async (id) => {
  const response = await apiClient.delete(`/programs/${id}`);
  return response.data;
};
